import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { IPost } from '../entities/posts.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsPostsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getPost(id: string): Observable<IPost> {
    return this.http.get<IPost>(`${this.apiUrl.base}/Postagem/ObterPorId`, {
      withCredentials: true,
      params: {
        id,
      },
    });
  }

  public getAllPostagens(): Observable<IPost[]> {
    return this.http.get<IPost[]>(`${this.apiUrl.base}/Postagem/ObterAtivas`, {
      withCredentials: true,
    });
  }

  public addPostagem(post: IPost): Observable<IPost> {
    return this.http.post<IPost>(
      `${this.apiUrl.base}/Postagem/Adicionar`,
      post,
      {
        withCredentials: true,
      }
    );
  }

  public updatePostagem(post: IPost): Observable<IPost> {
    return this.http.put<IPost>(
      `${this.apiUrl.base}/Postagem/Atualizar`,
      post,
      {
        withCredentials: true,
      }
    );
  }

  public deletePostagem(postId: string): Observable<any> {
    return this.http.delete(
      `${this.apiUrl.base}/Postagem/Remover?id=${postId}`,
      {
        withCredentials: true,
      }
    );
  }
}
